import { render, staticRenderFns } from "./ConfirmPay.vue?vue&type=template&id=0f73d576&scoped=true"
import script from "./ConfirmPay.vue?vue&type=script&lang=js"
export * from "./ConfirmPay.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPay.vue?vue&type=style&index=0&id=0f73d576&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f73d576",
  null
  
)

export default component.exports